import { computed, inject, onBeforeUnmount, onMounted, provide, ref, type InjectionKey, type Ref } from 'vue'

const typographyKey: InjectionKey<Readonly<Ref<string>>> = Symbol('conversation-typography')

/** One font-loading listener per conversation, shared by prose and composition. */
export function provideConversationTypography(fontFamily: Readonly<Ref<string>>): void {
  const revision = ref(0)
  let fonts: FontFaceSet | undefined
  const changed = () => { revision.value++ }
  provide(typographyKey, computed(() => `${fontFamily.value}:${revision.value}`))

  onMounted(() => {
    fonts = document.fonts
    fonts?.addEventListener('loadingdone', changed)
    fonts?.addEventListener('loadingerror', changed)
  })
  onBeforeUnmount(() => {
    fonts?.removeEventListener('loadingdone', changed)
    fonts?.removeEventListener('loadingerror', changed)
  })
}

export function useConversationTypography(): Readonly<Ref<string>> {
  return inject(typographyKey, ref(''))
}
